// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Task-pane styles — kept small; Office runs this inside a narrow WebView, so the layout
   is single-column and typography follows Microsoft's Fluent guidance loosely. */

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
  font-size: 14px;
  color: #201f1e;
  background: #faf9f8;
}

.taskpane {
  padding: 12px;
}

.taskpane h2 {
  font-size: 15px;
  margin: 0 0 8px 0;
}

.taskpane .subtitle {
  color: #605e5c;
  font-size: 12px;
  margin: 0 0 12px 0;
}

.field-label {
  display: block;
  font-size: 12px;
  color: #605e5c;
  margin: 12px 0 4px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.picker {
  width: 100%;
  padding: 6px 8px;
  font: inherit;
  border: 1px solid #8a8886;
  border-radius: 2px;
  background: #fff;
}

.chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  font-family: 'Consolas', 'Courier New', monospace;
  font-size: 12px;
  background: #edebe9;
  border: 1px solid transparent;
  border-radius: 12px;
  cursor: pointer;
  transition: background 120ms ease, border-color 120ms ease;
}

.chip:hover {
  background: #e1dfdd;
  border-color: #c8c6c4;
}

.chip.primary {
  background: #deecf9;
}

.chip.primary:hover {
  background: #c7e0f4;
}

.chip.region {
  background: #fff4ce;
}

.chip.region:hover {
  background: #ffe066;
}

.chip .icon {
  font-size: 10px;
  color: #605e5c;
}

.region-card {
  border: 1px solid #c8c6c4;
  border-radius: 4px;
  padding: 8px;
  margin: 6px 0 12px;
  background: #fff;
}

.region-card .region-hint {
  font-size: 11px;
  color: #605e5c;
  margin: 0 0 6px;
}

.info-banner {
  padding: 8px 10px;
  background: #fff4ce;
  border-left: 3px solid #dea100;
  font-size: 12px;
  margin: 8px 0;
}

.error-banner {
  padding: 8px 10px;
  background: #fde7e9;
  border-left: 3px solid #a4262c;
  font-size: 12px;
  margin: 8px 0;
}

.status {
  font-size: 12px;
  color: #605e5c;
  padding: 4px 0;
  min-height: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/styles.css"],"names":[],"mappings":"AAAA;iFACiF;;AAEjF;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,6DAA6D;EAC7D,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iDAAiD;EACjD,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* Task-pane styles — kept small; Office runs this inside a narrow WebView, so the layout\n   is single-column and typography follows Microsoft's Fluent guidance loosely. */\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;\n  font-size: 14px;\n  color: #201f1e;\n  background: #faf9f8;\n}\n\n.taskpane {\n  padding: 12px;\n}\n\n.taskpane h2 {\n  font-size: 15px;\n  margin: 0 0 8px 0;\n}\n\n.taskpane .subtitle {\n  color: #605e5c;\n  font-size: 12px;\n  margin: 0 0 12px 0;\n}\n\n.field-label {\n  display: block;\n  font-size: 12px;\n  color: #605e5c;\n  margin: 12px 0 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.picker {\n  width: 100%;\n  padding: 6px 8px;\n  font: inherit;\n  border: 1px solid #8a8886;\n  border-radius: 2px;\n  background: #fff;\n}\n\n.chip-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  font-family: 'Consolas', 'Courier New', monospace;\n  font-size: 12px;\n  background: #edebe9;\n  border: 1px solid transparent;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: background 120ms ease, border-color 120ms ease;\n}\n\n.chip:hover {\n  background: #e1dfdd;\n  border-color: #c8c6c4;\n}\n\n.chip.primary {\n  background: #deecf9;\n}\n\n.chip.primary:hover {\n  background: #c7e0f4;\n}\n\n.chip.region {\n  background: #fff4ce;\n}\n\n.chip.region:hover {\n  background: #ffe066;\n}\n\n.chip .icon {\n  font-size: 10px;\n  color: #605e5c;\n}\n\n.region-card {\n  border: 1px solid #c8c6c4;\n  border-radius: 4px;\n  padding: 8px;\n  margin: 6px 0 12px;\n  background: #fff;\n}\n\n.region-card .region-hint {\n  font-size: 11px;\n  color: #605e5c;\n  margin: 0 0 6px;\n}\n\n.info-banner {\n  padding: 8px 10px;\n  background: #fff4ce;\n  border-left: 3px solid #dea100;\n  font-size: 12px;\n  margin: 8px 0;\n}\n\n.error-banner {\n  padding: 8px 10px;\n  background: #fde7e9;\n  border-left: 3px solid #a4262c;\n  font-size: 12px;\n  margin: 8px 0;\n}\n\n.status {\n  font-size: 12px;\n  color: #605e5c;\n  padding: 4px 0;\n  min-height: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
